import React from 'react';
import { LeafIcon } from './Icons';

const LEARNING_STATUS_META = {
    NOT_LEARNED: {
        key: 'NOT_LEARNED',
        label: 'Nicht gelernt',
        color: '#dc2626',
        accentTextClass: 'text-red-600 dark:text-red-400'
    },
    IN_PROGRESS: {
        key: 'IN_PROGRESS',
        label: 'In Arbeit',
        color: '#f97316',
        accentTextClass: 'text-orange-500 dark:text-orange-300'
    },
    LEARNED: {
        key: 'LEARNED',
        label: 'Gelernt',
        color: '#16a34a',
        accentTextClass: 'text-plantlix-600 dark:text-plantlix-400'
    }
};

export const getLearningStatusMeta = (status = 'NOT_LEARNED') => {
    if (!status) return LEARNING_STATUS_META.NOT_LEARNED;
    return LEARNING_STATUS_META[status] || LEARNING_STATUS_META.NOT_LEARNED;
};

const LearningStatusBadge = ({
    status,
    showLabel = true,
    size = 'md',
    variant = 'solid',
    className = '',
    onClick = null,
    plantId = null,
    onUpdateStatus = null
}) => {
    const meta = getLearningStatusMeta(status);
    const paddingMapWithLabel = {
        sm: 'px-2.5 py-1',
        md: 'px-3 py-1.5',
        lg: 'px-3.5 py-1.5'
    };
    const paddingMapIconOnly = {
        sm: 'px-2 py-1',
        md: 'px-2.5 py-1.5',
        lg: 'px-3 py-1.5'
    };
    const fontSizeMap = {
        sm: 'text-[11px]',
        md: 'text-xs',
        lg: 'text-sm'
    };
    const iconSizeMap = {
        sm: showLabel ? 'w-3.5 h-3.5' : 'w-4 h-4',
        md: showLabel ? 'w-4 h-4' : 'w-5 h-5',
        lg: showLabel ? 'w-5 h-5' : 'w-6 h-6'
    };
    const paddingClasses = showLabel
        ? (paddingMapWithLabel[size] || paddingMapWithLabel.md)
        : (paddingMapIconOnly[size] || paddingMapIconOnly.md);
    const labelClasses = fontSizeMap[size] || fontSizeMap.md;
    const iconClasses = iconSizeMap[size] || (showLabel ? 'text-sm' : 'text-lg');
    const title = `Lernstatus: ${meta.label}${onClick ? ' (Klicken zum Wechseln)' : ''}`;
    const badgeStyle = variant === 'solid'
        ? {
            borderColor: `${meta.color}44`,
            boxShadow: `0 12px 32px -18px ${meta.color}80`
        }
        : {
            borderColor: `rgba(148, 163, 184, 0.3)`
        };
    const labelStyle = variant === 'solid' ? { color: meta.color } : {};

    const handleClick = (e) => {
        if (onClick) {
            e.stopPropagation();
            onClick(e);
        } else if (onUpdateStatus && plantId) {
            e.stopPropagation();
            const nextStatus = status === 'NOT_LEARNED' ? 'IN_PROGRESS'
                : status === 'IN_PROGRESS' ? 'LEARNED'
                    : 'NOT_LEARNED';
            onUpdateStatus(plantId, { learning_status: nextStatus }, true);
        }
    };

    return (
        <span
            onClick={handleClick}
            className={`inline-flex items-center justify-center gap-1 rounded-full font-semibold leading-tight tracking-wide transition-all duration-200 bg-white dark:bg-[#0f1318] border text-gray-700 dark:text-gray-200 ${paddingClasses} ${labelClasses} ${className} ${(onClick || onUpdateStatus) ? 'cursor-pointer hover:scale-110 active:scale-95' : ''}`}
            title={title}
            aria-label={title}
            style={badgeStyle}
        >
            <LeafIcon className={`${iconClasses} leading-none`} color={meta.color} />
            {showLabel && <span className="leading-none" style={labelStyle}>{meta.label}</span>}
        </span>
    );
};

export default LearningStatusBadge;
